import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageAccessService {
  readonly granted = signal(false);

  async ensure(): Promise<boolean> {
    if (this.granted()) return true;

    if (!('requestStorageAccess' in document)) {
      this.granted.set(true);
      return true;
    }

    const has = await document.hasStorageAccess().catch(() => false);
    if (has) {
      this.granted.set(true);
      return true;
    }

    try {
      await document.requestStorageAccess();
      this.granted.set(true);
      return true;
    } catch {
      return false;
    }
  }
}
